import { formatNumber } from './number.ts';
import type { Digits } from './digits.ts';
import type { Locale } from '../locale.ts';

/** minutes → "۲ ساعت و ۱۵ دقیقه" | "2h 15m"; < 1 min → "کمتر از یک دقیقه" | "<1m" */
export function formatDuration(minutes: number, locale: Locale, digits: Digits, opts: { short?: boolean } = {}): string {
  const total = Math.max(0, Math.round(minutes));
  const h = Math.floor(total / 60);
  const m = total % 60;
  const n = (v: number) => formatNumber(v, locale, digits);
  if (locale === 'fa') {
    if (total === 0) return 'کمتر از یک دقیقه';
    const parts: string[] = [];
    if (h) parts.push(`${n(h)} ساعت`);
    if (m) parts.push(`${n(m)} دقیقه`);
    return parts.join(opts.short ? ' ' : ' و ');
  }
  if (total === 0) return '<1m';
  const parts: string[] = [];
  if (h) parts.push(`${n(h)}h`);
  if (m) parts.push(`${n(m)}m`);
  return parts.join(' ');
}

/** Delay label: "+۴۵ دقیقه" | "+45m" (0 → "" ) */
export function formatDelay(minutes: number, locale: Locale, digits: Digits): string {
  if (!minutes) return '';
  const sign = minutes > 0 ? '+' : '−';
  return `${sign}${formatDuration(Math.abs(minutes), locale, digits, { short: true })}`;
}

/** Countdown pieces for a target instant. */
export function countdownParts(targetMs: number, nowMs: number) {
  const diff = targetMs - nowMs;
  const past = diff < 0;
  const abs = Math.abs(diff);
  const days = Math.floor(abs / 86_400_000);
  const hours = Math.floor((abs % 86_400_000) / 3_600_000);
  const minutes = Math.floor((abs % 3_600_000) / 60_000);
  const seconds = Math.floor((abs % 60_000) / 1000);
  return { past, days, hours, minutes, seconds, totalMs: abs };
}
